import type { ReactNode } from "react";

type Props = {
    title: string;
    status: "connected" | "disconnected" | "loading" | "error";
    detail?: string;
    action: { label: string; onAction: () => void };
    configuration?: { label: string; onAction: () => void };
    children?: ReactNode;
};

const labels = { connected: "Connected", disconnected: "Not connected", loading: "Checking connection", error: "Unable to load" };

export default function VendorIntegrationCard({ title, status, detail, action, configuration, children }: Props) {
    return (
        <s-section heading={title}>
            <s-stack gap="base">
                <s-grid gridTemplateColumns="1fr auto" alignItems="center" gap="base">
                    <s-stack gap="small-100">
                        <s-text tone={status === "error" ? "critical" : "auto"}>{labels[status]}</s-text>
                        {detail && <s-text color="subdued">{detail}</s-text>}
                    </s-stack>
                    <s-button variant={status === "disconnected" ? "primary" : "secondary"} onClick={action.onAction}
                        disabled={status === "loading"}>{action.label}</s-button>
                </s-grid>
                {status === "connected" && configuration && <s-stack direction="inline">
                    <s-link onClick={configuration.onAction}>{configuration.label}</s-link>
                </s-stack>}
                {children}
            </s-stack>
        </s-section>
    );
}
